import 'classlist-polyfill';

import wrapper from 'wrapper';
import wsConfig from '@bbc/news-vj-lang-config';
import Map, { identifier } from './map';
import events from './components/map-events/map-events';

import data from './assets/data/china';

const { language } = wrapper.meta();
const { locale } = wsConfig[language];

function render(dom, id) {
    const {
        province, infected, deceased, paths,
    } = dom;
    const region = data[id];
    province.innerHTML = region[`name-${__('lang')}`];
    infected.innerHTML = peoplePhrase(region.infected || 0);
    deceased.innerHTML = peoplePhrase(region.deceased || 0);

    // highlight selected region
    const selected = findPath(paths, id);
    paths.forEach(p => {
        const path = p;
        path.style.stroke = '#fff';
        path.style.strokeWidth = 1;
    });
    if (!selected) {
        return;
    }
    selected.style.stroke = 'steelblue';
    selected.style.strokeWidth = 2;
    selected.parentNode.append(selected);
}

function peoplePhrase(number) {
    return __('people').replace('§', number.toLocaleString(locale));
}

function findPath(paths, id) {
    return paths.find(path => path.id === id);
}

function queryDOM(root) {
    return {
        province: root.querySelector('.province'),
        breakdown: root.querySelector('.breakdown'),
        infected: root.querySelector('.breakdown__value--infected'),
        deceased: root.querySelector('.breakdown__value--deceased'),
        infectedBar: root.querySelector('.breakdown__decoration--infected .breakdown__bar'),
        paths: Array.from(root.querySelectorAll('svg path'))
            .concat(root.querySelector('g.region'))
            .filter(el => !!(el.id)),
    };
}

async function main() {
    const root = wrapper.select('#vjeastasia-498');
    await Map.build(root, `${wrapper.path().projectAssets}/img/china.svg`, data);
    const dom = queryDOM(root);
    root.classList.remove('no-js');

    events.on('vj-map', ({ type, content: id }) => {
        if (type !== 'region-changed') {
            return;
        }
        render(dom, id);
    }, identifier);

    events.emit('vj-map', {
        type: 'region-changed',
        content: 'ZH',
        id: identifier,
    });

    wrapper.markPageAsLoaded();
}

try {
    main();
}
catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
}
